/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') { 
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus, form);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.addUpsellItem = function(id, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=1&id=' + id,
    dataType: 'json',
    success: function(cart) {
      $('.cart-upsell__wrapper').remove();
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      // $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      // $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, reLoadCart;

  // Private general variables
  var settings, isUpdating, $body, $formActionType, discountPercent;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $cartFormContainer, $upsellSelector;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, renderProductDrawerCart, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, cartFeedback, shippingCartPopup, cartShippingPopupCallback, openDrawerAfterCartUpdate = false;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartFormSelector   : '#cartForm',
      cartContainer      : '.CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      upsellProducts     : '.product-upsell-wrapper .product-upsells__col'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartFormContainer = $(settings.cartFormSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $upsellSelector    = $(settings.upsellProducts);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Track Wholesale discount
    discountPercent = 0;

    if (!settings.disableAjaxCart) {
      formOverride();
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    shippingCartPopup();
  };
  reLoadCart = function () {
    if(location.pathname.indexOf('cart') == -1) {
      ShopifyAPI.getCart(updateCountPrice);
    }    
  };
  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      if (discountPercent != 0) {
        var discountAmount = cart.total_price * discountPercent / 100;
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price - discountAmount, settings.moneyFormat));
      } else {
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      }
    }
  };

  shippingCartPopup = function () {
    /*$cartFormContainer.on('submit', function(evt) {
      if (('false' == 'true') && !$(document.activeElement).hasClass('update-cart')) {
        evt.preventDefault();
        ShopifyAPI.getCart(cartShippingPopupCallback);
      }
    });*/
  };

  cartShippingPopupCallback = function(cart) {
    $.each(cart.items, function(index, cartItem) {
      jQuery.getJSON('/products/' + cartItem.handle + '.js', function(product) {
        var product_tag = product.tags;
        if (product_tag.indexOf('cart_checkout_popup') !== -1) {
          theme.ShippingModal.onlyShow();
          return false;
        }
        if (index == cart.items.length - 1) {
          window.location = '/checkout';
        }
      });
    });
  };

  var upSellUtil = {
    data: [],
    ini: 0,
    total: 0,
    action: 'add',
    reset: function() {
      this.ini = 0,this.data = [];
    },
    ajaxpost: function(uri, params, callback){
      $.ajax({
        type: 'POST',
        url: uri,
        dataType: 'json',
        async: false,
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){}
      });
    },
    addItem: function(qty, id, properties, callback) {
      var params = {quantity: qty,id: id};
      if (properties != false){
        params.properties = properties;
      }
      upSellUtil.ajaxpost('/cart/add.js', params, callback);
    },
    updateItem: function(qty, id, properties, callback){
      var params = {updates: {id: qty}};
      if(properties != false){
        params.properties = properties;
      }
      upSellUtil.ajaxpost('/cart/update.js', params, callback);
    },
    recursive: function(){
      if (upSellUtil.data.length > 0) {
        var actionname = (upSellUtil.action == 'update') ? 'updateItem' : 'addItem' ;
        upSellUtil[actionname](upSellUtil.data[upSellUtil.ini].qty, upSellUtil.data[upSellUtil.ini].id, upSellUtil.data[upSellUtil.ini].properties, function(){
          upSellUtil.ini += 1;
          if(upSellUtil.ini < upSellUtil.total){
            upSellUtil.recursive();
          }else{
            return false;
          }
        });
      } else {
        return false;
      }
    },
    begin:function(){
      upSellUtil.data = [];
      upSellUtil.ini = 0;
      $upsellSelector.each(function(){
        var $el = $(this);
        if ($el.hasClass('active')) {
          var variant_id = $el.data('variant-id');
          upSellUtil.data.push({id: variant_id, quantity: 1});
        }
      });
      upSellUtil.total = upSellUtil.data.length;
      upSellUtil.action = 'add';
      upSellUtil.recursive();
    }
  }

  formOverride = function () {
    function isProductPageForm(form) {
      return form && document.body.classList.contains('template-product') &&
        form.matches('.product-form:not(.product-card__form)');
    }

    function addProductToDrawer(form, evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (form.dataset.cartPending === 'true' || !form.reportValidity()) return;
      form.dataset.cartPending = 'true';
      var buttons = $(form).find('.product-form__cart-submit');
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      var payload = new FormData(form);
      payload.delete('return_to');
      buttons.addClass('is-adding').attr('aria-busy', 'true');
      $(form).find('.qty-error').remove();

      $.ajax({
        type: 'POST', url: root + 'cart/add.js', data: payload,
        processData: false, contentType: false, dataType: 'json'
      }).then(function() {
        return $.getJSON(root + 'cart.js');
      }).then(function(cart) {
        openDrawerAfterCartUpdate = true;
        cartUpdateCallback(cart);
        buttons.addClass('is-added');
        $body.trigger('afterGetCart.ajaxCart', [cart]);
      }).fail(function(error) {
        openDrawerAfterCartUpdate = false;
        var response = error.responseJSON;
        $('<p class="qty-error" role="alert">').text(response && response.description || "Unable to update your cart. Please try again.").appendTo(form);
      }).always(function() {
        delete form.dataset.cartPending;
        buttons.removeClass('is-adding').removeAttr('aria-busy');
      });
    }

    if (!document.body.dataset.productDrawerBound) {
      document.body.dataset.productDrawerBound = 'true';
      document.addEventListener('click', function(evt) {
        var button = evt.target.closest && evt.target.closest('.product-form__cart-submit');
        if (!button || button.disabled) return;
        var form = button.form || $(button).closest('.product-template').find('.product-form:not(.product-card__form)')[0];
        if (isProductPageForm(form)) addProductToDrawer(form, evt);
      }, true);
      document.addEventListener('submit', function(evt) {
        if (evt.submitter && evt.submitter.closest('.shopify-payment-button')) return;
        if (isProductPageForm(evt.target)) addProductToDrawer(evt.target, evt);
      }, true);
    }

    $(document.body).on('submit', settings.formSelector, function(evt) {
      if ( !$(evt.target).hasClass('cart-widget') && $(evt.target).hasClass('product-form')) {
        if (isProductPageForm(evt.target)) {
          addProductToDrawer(evt.target, evt);
          return;
        }
        var submitter = evt.originalEvent && evt.originalEvent.submitter ? evt.originalEvent.submitter : document.activeElement;
        openDrawerAfterCartUpdate = openDrawerAfterCartUpdate || $(submitter).closest('.product-form__cart').length > 0;
        var disableAjax = $(evt.target).data('action-type') == 'add_to_cart_redirect' && !openDrawerAfterCartUpdate;

        if (!$(evt.target).hasClass('product-card__form')) {
          upSellUtil.begin();
        }

        if (disableAjax) {
          return true;
        }

        evt.preventDefault();
        evt.stopPropagation();

        // Add class to be styled if desired
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();
  
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      }
    });
  };

  itemAddedCallback = function (product, form) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    var img, $form = $(form);
    $formActionType = $form.data('action-type');
    if (openDrawerAfterCartUpdate) {
      ShopifyAPI.getCart(cartUpdateCallback);
      return;
    }
    var shipping_popup = 'false';
    var product_tags = $(form).data('tags') ? $(form).data('tags') : '';
    var show_shipping_popup = ((shipping_popup == 'true') && (product_tags.indexOf('product_checkout_popup') !== -1)) ? true: false;

    if ((theme.isMobile() && ('all' == 'desktop')) ||
        (!theme.isMobile() && ('all' == 'mobile'))) {
      show_shipping_popup = false;
    }
    // Product card action
    if ($form.hasClass('product-card__form')) {
      var page = $('main.main-content').data('page-template');
      if(page != 'cart' || page != 'product') show_shipping_popup = false;
      img = $form.parents('.product-card').find('img')[0];
      if (($formActionType == 'add_to_cart_checkout') && !show_shipping_popup) {
        window.location = '/checkout';
      } else {
        if (show_shipping_popup && ('drawer' == 'page')) {
          theme.ShippingModal.onlyShow();
        } else if($formActionType == 'add_to_cart') {
          if(!show_shipping_popup || ('drawer' == 'stay_page')){
            ShopifyAPI.getCart(cartUpdateCallback);
          }
        } else {
          cartFeedback(img);
        }
      }
    }
    // Product page action
    else {
      img = $form.parents('.product-template, .section-featured-product').find('.product-images__image .slick-active img, .product-images--single img')[0];

      if (!img) {
        img = $form.parents('.product-template, .section-featured-product').find('.product-images__image .slick-active .video-container, .product-images--single .video-container')[0];
      }

      if (($formActionType == 'add_to_cart_checkout') && !show_shipping_popup) {
        ShopifyAPI.getCart(cartUpdateCallback);
        window.location = '/checkout';
      } else if ($formActionType == 'add_to_cart') {
        if(!show_shipping_popup || ('drawer' == 'stay_page')){
            ShopifyAPI.getCart(cartUpdateCallback);
          }
      } else {
        if (show_shipping_popup && ('drawer' == 'page')) {
          theme.ShippingModal.onlyShow();
        } else {
          cartFeedback(img, 'floating-cart--big');
        }
      }
    }

  };

  cartFeedback = function (img, cartClass) {
    if (theme.isDesktop() && img) {
      var position = $(img).offset();
      var right = $(theme.cache.$body).width() - position.left - $(img).width();

      var cart_type = 'drawer';
      var isAnimationEnabled = 'false' === 'true';
      if(cart_type != 'popup' && isAnimationEnabled){
        $("body").append('<div class="floating-cart '+ cartClass +'"></div>');
        var cart = $('div.floating-cart');
        $("<img src='"+img.src+"' class='floating-image-large' />").appendTo(cart);

        $(cart).css({'top' : position.top + 'px', "right" : right + 'px'}).fadeIn("slow").addClass('moveToCart');
        setTimeout(function(){
          $("body").addClass("MakeFloatingCart");
          ShopifyAPI.getCart(cartUpdateCallback);
        }, 400);

        setTimeout(function(){
          $('div.floating-cart').remove();
          $("body").removeClass("MakeFloatingCart");
        }, 850);
      }else{
        ShopifyAPI.getCart(cartUpdateCallback);
      }
    } else {
      ShopifyAPI.getCart(cartUpdateCallback);
    }
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, form) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $.notify({
          title: 'Error',
          text: data.description,
        }, {
          style: 'metro',
          autoHide: true,
          clickToHide: true,
          className: 'error'
        });
      }
    }
  };

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    if (openDrawerAfterCartUpdate) {
      renderProductDrawerCart(cart);
      cartCallback(cart);
      return;
    }
    buildCart(cart);
  };

  renderProductDrawerCart = function (cart) {
    var $drawerCart = $('#CartDrawer .CartContainer');
    var escapeHtml = function (value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
      });
    };

    if (cart.item_count === 0) {
      $drawerCart.html($('#EmptyCartDrawerTemplate').html());
      return;
    }

    var rows = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
      return '<tr class="ajaxcart__row" data-line="' + (index + 1) + '" data-line-price="' + item.price + '">' +
        '<td class="cart-table__image"><a href="' + escapeHtml(item.url) + '" class="cart__image">' + image + '</a></td>' +
        '<td class="cart-table__details"><a href="' + escapeHtml(item.url) + '" class="cart-table__item-title">' + escapeHtml(item.product_title) + '</a>' + variant +
        '<div class="cart-table__item-controls"><div class="ajaxcart__qty">' +
        '<button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text" data-id="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" data-line="' + (index + 1) + '"><span class="icon icon-minus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">&minus;</span></button>' +
        '<input type="text" name="updates[]" class="ajaxcart__qty-num" value="' + item.quantity + '" min="0" data-id="' + escapeHtml(item.key) + '" data-line="' + (index + 1) + '" aria-label="quantity" pattern="[0-9]*">' +
        '<button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text" data-id="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" data-line="' + (index + 1) + '"><span class="icon icon-plus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">+</span></button>' +
        '</div><a href="/cart/change?line=' + (index + 1) + '&quantity=0" class="cart__remove" data-line="' + (index + 1) + '"><span class="icon icon-trash" aria-hidden="true"></span></a></div></td>' +
        '<td class="cart-table__summary"><span class="h4">' + Shopify.formatMoney(item.final_line_price, settings.moneyFormat) + '</span></td></tr>';
    }).join('');

    var html = '<form action="/cart" method="post" novalidate class="cart ajaxcart cart-widget">' +
      '<div class="cart-drawer__items overflow-wrapper"><table class="cart-table full"><tbody>' + rows + '</tbody></table></div>' +
      $('#CartDrawerUpsellTemplate').html() +
      '<div class="cart-drawer__footer"><div class="cart-summary"><div class="grid--full">' +
      '<div class="grid__item one-half cart-summary__subtotal-title h5">' + "Subtotal" + ' (' + cart.item_count + ')</div>' +
      '<div class="grid__item one-half cart-summary__subtotal h3"><span class="cart-summary__current-price">' + Shopify.formatMoney(cart.total_price, settings.moneyFormat) + '</span></div>' +
      '</div></div><button type="submit" class="btn btn--special btn--full cart__checkout-btn" name="checkout">' + "Check Out" + '</button></div></form>';

    $drawerCart.html(html);
    $drawerCart.find('form').attr('action', (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart');
    $drawerCart.find('.ajaxcart__qty--minus').attr('aria-label', "Reduce item quantity by one");
    $drawerCart.find('.ajaxcart__qty--plus').attr('aria-label', "Increase item quantity by one");
    $drawerCart.find('.cart__remove').attr('aria-label', "Remove");
  };

  buildCart = function (cart) {

    if (document.body.classList.contains('template-product')) {
      renderProductDrawerCart(cart);
      $body.removeClass('drawer--is-loading');
      cartCallback(cart);
      return;
    }

    // Start with a fresh cart div
    $cartContainer.each(function(){
      $(this).empty();
    });

    discountPercent = $body.data('discount-percent');

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.each(function(){
        if ($(this).closest('#CartDrawer').length) {
          $(this).html($('#EmptyCartDrawerTemplate').html());
        } else {
          $(this)
          .append('<p class="alert-info">' + "Your cart is currently empty" + '</p>');
          $(this)
          .append('<p class="text-center"><a href="/collections/all" class="btn btn--special">Shop Now</a></p>');
        }
      });
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        linePrice = 0,
        totalPrice = 0,
        upsellProduct = {};

    // Add each item to our handlebars.js data

    if (upsell_product) {
      upsellProduct = {
        url: upsell_product.url,
        title: upsell_product.title,
        featured_image: upsell_product.featured_image,
        price_varies: upsell_product.price_varies,
        price_min: upsell_product.price_min,
        price_min_html: Shopify.formatMoney(upsell_product.price_min, settings.moneyFormat),
        price_max: upsell_product.price_max,
        price_max_html: Shopify.formatMoney(upsell_product.price_max, settings.moneyFormat),
        compare_at_price: upsell_product.compare_at_price,
        compare_at_price_html: Shopify.formatMoney(upsell_product.compare_at_price, settings.moneyFormat),
        price: upsell_product.price,
        price_html: Shopify.formatMoney(upsell_product.price, settings.moneyFormat),
        selected_or_first_available_variant_id: upsell_product.variants[0].id
      };
    }

    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array

      if (discountPercent != 0) {
        linePrice = cartItem.original_line_price - (cartItem.original_line_price * discountPercent / 100);
      } else {
        linePrice = cartItem.original_line_price;
      }
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price_strip: cartItem.price,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(linePrice, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        finalLinePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    var cartMethodIsDrawer = false;
    if('drawer' === 'drawer'){
      cartMethodIsDrawer = true;
    }
    // Gather all cart data and add to DOM
    if (discountPercent != 0) {
      totalPrice = cart.total_price - (cart.total_price * discountPercent / 100);
    } else {
      totalPrice = cart.total_price;
    }
    data = {
      cartMethodIsDrawer: cartMethodIsDrawer,
      isOverflow: _.keys(items).length > 3,
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(totalPrice, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      upsellProduct: upsellProduct
    }

    $('.section-header__cart-price').html(Shopify.formatMoney(totalPrice, settings.moneyFormat));
    $('.section-header__cart-count').html(cart.item_count);
    $('.cart-summary__subtotal').html(Shopify.formatMoney(totalPrice, settings.moneyFormat));

    $cartContainer.each(function(){
      $(this).append(template(data));
    });
    var page = $('main.main-content').data('page-template');
    if(page == 'cart'){
      var $formTableData = $cartContainer.find('table').html();
      $('#cartForm').find('table').html($formTableData);
    }
    //Hide "OR" word if the additional checkout button is hidden
    var additional_buttons = $cartContainer.find('button.additional-checkout-button');

    var arr_btns = [];
    additional_buttons.each(function (i) {
      arr_btns[i] = $(this).css('display') == 'none';
    });

    function btn(hidden) {
      return hidden == true;
    }

    if(arr_btns.every(btn) == true){
      $cartContainer.each(function(){
        $(this).find('.additional-checkout-buttons').css('display', 'none');
      });
    }

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    // Prevent cart auto-openning on cart page
    if (theme.cache.$body.hasClass('template-cart')) {
      return false;
    }

    if (openDrawerAfterCartUpdate && theme.RightDrawer) {
      openDrawerAfterCartUpdate = false;
      $formActionType = undefined;
      $body.removeClass('drawer--is-loading');
      if (!theme.RightDrawer.drawerIsOpen) {
        theme.RightDrawer.open();
      }
      return false;
    }

    if (theme.ShippingModal && theme.ShippingModal.modalIsOpen) {
      if ('add_to_cart_redirect' == 'add_to_cart_redirect') {
        window.location = '/cart';
      } else {
        window.location = '/checkout';
      }
    } else {
      if ('add_to_cart_drawer' == 'add_to_cart_popup' && theme.isMobile() || 'add_to_cart_drawer' == 'add_to_cart_popup') {
        if (typeof $formActionType !== 'undefined') {
          if (!$('body').hasClass('js-drawer-open')) {
            theme.cartModal.onlyShow();
          }
        }
      } else if(('drawer' == 'page') || ('drawer' == 'stay_page')) {
        if($formActionType == 'add_to_cart_redirect'){
          window.location = '/cart';
        } else if($formActionType == 'add_to_cart_checkout') {
          window.location = '/checkout';
        }
      } else {
        if ('add_to_cart_drawer' == 'add_to_cart_drawer' && theme.isMobile() || 'add_to_cart_drawer' == 'add_to_cart_drawer') {
          if (typeof $formActionType !== 'undefined') {
            $body.removeClass('drawer--is-loading');
            $body.trigger('afterCartLoad.ajaxCart', cart);
          }
        }
      }
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    //Remove product from cart
    //change quantity to 0
    $body.on('click', '.ajaxcart__remove, #CartDrawer .cart__remove', function (e) {
      e.preventDefault();

      if (isUpdating) {
        return;
      }

      var line = $(this).data('line');
      var qty = 0;

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        // if (qty <= 1) qty = 1;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    $body.on('click', '[data-upsell-direction]', function() {
      var track = this.closest('.drawer-upsell').querySelector('.drawer-upsell__track');
      track.scrollBy({
        left: Number(this.dataset.upsellDirection) * track.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });

    $body.on('click', '[data-drawer-upsell-add]', function() {
      var button = this;
      var $error = $(button).siblings('.drawer-upsell__error');
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      $error.prop('hidden', true).text('');
      jQuery.ajax({
        type: 'POST',
        url: root + 'cart/add.js',
        dataType: 'json',
        data: { quantity: 1, id: button.dataset.drawerUpsellAdd }
      }).then(function() {
        return jQuery.getJSON(root + 'cart.js').then(function(cart) {
          cartUpdateCallback(cart);
          $(document.body).trigger('afterGetCart.ajaxCart', cart);
        });
      }).fail(function(xhr) {
        var response = xhr.responseJSON;
        $error.text(response && response.description ? response.description : "Unable to update your cart. Please try again.").prop('hidden', false);
      }).always(function() {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    });

    $body.on('click', '.ajaxcart__cart-upsell__btn', function() {
      var variant_id = $(this).data('variant-id');
      ShopifyAPI.addUpsellItem(variant_id);
      setTimeout(function() {
        isUpdating = false;
        ShopifyAPI.getCart(buildCart);
      }, 150);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(function(updatedCart) {
        if (theme.RightDrawer && theme.RightDrawer.drawerIsOpen) {
          renderProductDrawerCart(updatedCart);
        } else {
          buildCart(updatedCart);
        }
      });
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');
    var currentQty = 1;
    var $inputHtml;

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        $inputHtml = $(template(data));

        $inputHtml.find('.js-qty__adjust--minus').prop('disabled', validateQty(parseInt(itemQty, 10)) <= 1);

        if ($el.prop('disabled')) {
          $inputHtml.find('button, input').attr("disabled", true);
        }

        // Append new quantity selector then remove original
        $el.after($inputHtml).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {

        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, '')),
            line = $el.parents('.cart-table tr').data('line');

        var qty = validateQty(qty);

        discountPercent = $el.data('discount-percent');

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty = Math.max(1, qty - 1);
        }

        // Update the input's number
        $qtySelector.val(qty);
        $el.siblings('.js-qty__adjust--minus').prop('disabled', qty <= 1);

        // Vlad: Added to update quantity automatically on cart page
        if (line) {
          ShopifyAPI.changeItem(line, qty, adjustCartCallback);
        }
      });

      // Vlad: Added to update quantity automatically on cart page
      $('.cart-template .js-qty__num').on('focus', function() {
        currentQty = $(this).val();
      });
      $('.cart-template .js-qty__num').on('blur', function() {
        if (isUpdating) {
          return;
        }

        var $el = $(this),
            line = $el.parents('.cart-table tr').data('line'),
            qty = parseInt($el.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        if (currentQty == qty) {
          return;
        }

        // If it has a data-line, update the cart
        if (line) {
          isUpdating = true;
          setTimeout(function() {
            ShopifyAPI.changeItem(line, qty, adjustCartCallback);
          }, 500);
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    reload: reLoadCart,
    qtySelectors: qtySelectors
  };

  return module;

}(ajaxCart || {}, jQuery));
$(document).ready(function(){
  ajaxCart.reload();
});
